import Reveal from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Ecosystem Convergence",
    body: "Listings, events, packages, stories and bookings — the entire Southern African travel economy converges into a single marketplace, so partners stop scattering their presence across a dozen platforms.",
    img: "https://images.unsplash.com/photo-1600521605615-a8d3a23d8262?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Chobe National Park · Botswana",
  },
  {
    num: "02",
    title: "Direct Operator Liquidity",
    body: "We connect lodges, operators and agencies directly, stripping out friction so inventory flows from the bush to the world in real time — with margins that stay where they belong.",
    img: "https://images.unsplash.com/photo-1639402479478-f5e7881c0ccc?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Sossusvlei · Namibia",
  },
  {
    num: "03",
    title: "Pan-Southern African Scope",
    body: "Botswana, Namibia, South Africa and Zimbabwe — four countries, one connected trade network with genuine local depth, from the Okavango's channels to Victoria Falls' thunder.",
    img: "https://images.unsplash.com/photo-1600521675573-6947b3dfd106?crop=entropy&cs=srgb&fm=jpg&q=85",
    caption: "Victoria Falls · Zimbabwe",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="border-t border-goldline bg-coal/40">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-8 lg:px-16 lg:py-32">
        <Reveal>
          <p className="kicker mb-6">The Manifesto</p>
          <h2 className="max-w-2xl font-serif text-3xl font-semibold leading-snug tracking-tight sm:text-4xl lg:text-5xl">
            Three convictions, <span className="text-gold">one connected continent.</span>
          </h2>
        </Reveal>

        <div className="mt-20 space-y-24">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={0.1}>
              <div
                className={`grid items-center gap-10 lg:grid-cols-12 ${
                  i % 2 === 1 ? "lg:[direction:rtl]" : ""
                }`}
              >
                <div className="lg:col-span-2 lg:[direction:ltr]">
                  <span className="font-mono text-6xl font-medium text-gold/25 sm:text-7xl">{c.num}</span>
                </div>
                <div className="lg:col-span-6 lg:[direction:ltr]">
                  <h3 className="font-serif text-2xl font-semibold text-cream sm:text-3xl">{c.title}</h3>
                  <p className="mt-4 max-w-xl text-base leading-relaxed text-muted">{c.body}</p>
                </div>
                <div className="group lg:col-span-4 lg:[direction:ltr]">
                  <div className="relative overflow-hidden rounded-xl border border-goldline">
                    <img
                      src={c.img}
                      alt={c.caption}
                      className="photo-treat h-56 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
                    <p className="absolute bottom-3 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-gold/90">
                      {c.caption}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
